"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaMessageSend = void 0;
const domain_1 = require("@home-health-notify/domain");
const react_1 = require("react");
const context_1 = require("../context");
const utils_1 = require("../utils");
const useMediaMessageSend = (onUploadProgress, onDone, onUploadError, signedUrlUploader, platform, chat, createSendMediaResponseCallback) => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const onSend = (mediaMessages) => __awaiter(void 0, void 0, void 0, function* () {
        const uploadProgress = {
            uploadedSize: {},
            uploadedStatus: {},
        };
        const uploadedResults = [];
        const totalSize = mediaMessages
            .map(m => m.mediaFile.size)
            .reduce((a, b) => a + b, 0);
        const updateProgress = () => {
            const uploadedSize = Object.values(uploadProgress.uploadedSize).reduce((a, b) => a + b, 0);
            const uploadPct = totalSize > 0 ? (uploadedSize / totalSize) * 100 : 0;
            const uploadedFiles = Object.values(uploadProgress.uploadedStatus).filter(status => !!status).length;
            onUploadProgress({
                uploadPct,
                uploadedFiles,
                totalFiles: mediaMessages.length,
            });
        };
        const onMediaUploadProgress = (uploadProgressData) => {
            uploadProgress.uploadedSize[uploadProgressData.key] =
                uploadProgressData.uploadedSize;
            uploadProgress.uploadedStatus[uploadProgressData.key] =
                uploadProgressData.remainingSize === 0;
            updateProgress();
        };
        const handleUploadError = (file, error) => {
            onUploadError(file, error);
        };
        const getMediaUploadSuccessHandler = (mediaMessage) => {
            return (uploadResult) => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b, _c;
                const { mediaFile } = mediaMessage;
                let uploadedThumbnailUrl;
                if (mediaFile.isVideo()) {
                    const thumbnail = yield ((_b = (_a = mediaMessage.mediaFile).getThumbnail) === null || _b === void 0 ? void 0 : _b.call(_a));
                    if (thumbnail) {
                        if (mediaFile.dimension) {
                            (_c = thumbnail.setDimension) === null || _c === void 0 ? void 0 : _c.call(thumbnail, mediaFile.dimension.width, mediaFile.dimension.height);
                        }
                        const thumbnailDraft = new domain_1.MediaDraft(thumbnail, "");
                        // Upload thumbnail using uploadMedia but with no progress tracking
                        yield uploadMedia(thumbnailDraft, () => (result) => __awaiter(void 0, void 0, void 0, function* () {
                            uploadedThumbnailUrl = result.url;
                        }), false, // Pass false to exclude from progress
                        true);
                    }
                }
                const result = {
                    mediaFile: mediaMessage.mediaFile,
                    uploadedUrl: uploadResult.url,
                    uploadedThumbnailUrl,
                };
                if (!mediaMessage.mediaFile.isAudio()) {
                    result.text = mediaMessage.text;
                }
                uploadedResults.push(result);
            });
        };
        const uploadMedia = (mediaMessage_1, successHandler_1, ...args_1) => __awaiter(void 0, [mediaMessage_1, successHandler_1, ...args_1], void 0, function* (mediaMessage, successHandler, trackProgress = true, isThumbnail) {
            const uniqueName = mediaMessage.mediaFile.getUniqueNameWithDimensions();
            const key = `${platform}_${uniqueName}`;
            return new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
                const errorHandler = (file, error) => {
                    handleUploadError(file, error);
                    reject(error);
                };
                yield (selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.assetManager.uploadToSignedUrl(mediaMessage.mediaFile, key, signedUrlUploader, trackProgress ? onMediaUploadProgress : () => { }, // Only track progress if requested
                (uploadResult) => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        yield (successHandler || getMediaUploadSuccessHandler)(mediaMessage)(uploadResult);
                        resolve();
                    }
                    catch (error) {
                        reject(error);
                    }
                }), errorHandler, isThumbnail));
            }));
        });
        const sendAllMessages = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!chat) {
                throw new Error("Error sending message, chat not available");
            }
            const orderedResults = mediaMessages
                .map(x => uploadedResults.find(y => x.mediaFile === y.mediaFile))
                .filter(x => !!x);
            for (const result of orderedResults) {
                const responseCallback = createSendMediaResponseCallback === null || createSendMediaResponseCallback === void 0 ? void 0 : createSendMediaResponseCallback();
                yield chat.sendMedia(result, responseCallback);
            }
            onDone();
        });
        updateProgress();
        try {
            yield (0, utils_1.executeInParallel)(mediaMessages, uploadMedia, 2);
        }
        catch (error) {
            console.log("Error uploading media messages:", error);
        }
        yield sendAllMessages();
    });
    return {
        onSend,
    };
};
exports.useMediaMessageSend = useMediaMessageSend;
